<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" id="apt1" title="Part I: Organization">
<p class="h2p"><span class="right_1" epub:type="pagebreak" id="page_6" title="6"><a href="#/text/Contents#pt1">PART I</a></span></p>
<p class="h2p1"><a href="#/text/Contents#pt1">Organization</a></p>
<p class="epi"><i>“Organizing is what you do before you do something, so that when you do it, it is not all mixed up.”</i></p>
<p class="epi1"><b>—A.A. MILNE</b></p>
<p class="noindent1a">Modern journaling is more than simply writing your daily thoughts in a notebook. Today’s journal enthusiast demands a private space to contemplate life, as well as a system that can be an all-in-one organizational solution. The trick is to keep it all organized from the beginning.</p>
<p class="indent">Starting a journal from scratch can be intimidating at first, but it doesn’t need to be. Like most other things in life, the process is very simple if you break it down. This section will help you choose a journal, give it purpose, and develop a routine that molds to your lifestyle.</p>
<figure>
<p class="image1"><img alt="" height="539" src="images/f0006-01.jpg" width="405"/></p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part001.vue?5439c71d